<div class="box">
  <pa-button
    label="Открыть фильтры"
    icon="pi pi-filter"
    severity="secondary"
    (click)="openFilters()"
  ></pa-button>
</div>

